import { render, staticRenderFns } from "./BtnSocial.vue?vue&type=template&id=1039832c&"
import script from "./BtnSocial.vue?vue&type=script&setup=true&lang=js&"
export * from "./BtnSocial.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports